<!--
  A view that shows details of the scanned passenger's boarding pass
-->
<template>
  <div class="boarding_pass_confirm">
    <div class="boarding_pass_confirm_image">
      <img :src="successIcon"/>
    </div>

    <h2 class="subtitle">{{$t(`${pagei18nKey}.weFoundFollowingDetails`)}}</h2>
    <div class="columns"> 
      <div class="column boarding_pass_confirm_label">{{$t(`${pagei18nKey}.name`)}}</div>
      <div class="column boarding_pass_confirm_value">{{ firstName }}</div>
    </div>

    <div class="columns"> 
      <div class="column boarding_pass_confirm_label">{{$t(`${pagei18nKey}.flightNumber`)}}</div>
      <div class="column boarding_pass_confirm_value">{{ flightNumber }}</div>
    </div>

    <div class="columns"> 
      <div class="column boarding_pass_confirm_label">{{$t(`${pagei18nKey}.dateOfFlight`)}}</div>
      <div class="column boarding_pass_confirm_value">{{ flightDate }}</div>
    </div>

    <div class="columns"> 
      <div class="column boarding_pass_confirm_label">{{$t(`${pagei18nKey}.departureAirport`)}}</div>
      <div class="column boarding_pass_confirm_value">{{ departureAirport }}</div>
    </div>

    <div class="columns"> 
      <div class="column boarding_pass_confirm_label">{{$t(`${pagei18nKey}.arrivalAirport`)}}</div>
      <div class="column boarding_pass_confirm_value">{{ arrivalAirport }}</div>
    </div>
    
    
    <div class="section_subtitle">{{$t(`${pagei18nKey}.areAboveDetailsCorrect`)}}</div>
    <!-- Button -->
    <div class="boarding_pass_confirm_button__container">
      <ms-navigation-bar
        :buttons="[ backButton, nextButton ]"
        @navigationButtonClick="navigationButtonClick"
      />
    </div>

    <!-- no boarding pass, link to enter manually -->
    <div class="boarding_pass_enter_manually">
      <span
        @click="onEnterDetailsManuallyClicked"
        class="link-text">
        {{$t(`${pagei18nKey}.enterFlightDetailsManually`)}}
      </span>
    </div>

  </div>
</template>
<script>
  import api from '@/api/api'
  import {ButtonStates, ButtonTypes} from '@/components/app-button'
  import MsNavigationBar, {DefaultNavigationButtons} from '@/components/ms-navigation-bar'
  import { DateTime as LuxonDateTime } from 'luxon'

  export default {
    name: 'BoardingPassConfirmView',
    components: {
      MsNavigationBar
    },
    computed: {
      firstName: {
        get () {
          if (this.$store.getters.boardingPass) {
            return this.$store.getters.boardingPass.firstName + ' ' + this.$store.getters.boardingPass.lastName
          } else {
            return ''
          }
        }
      },
      flightNumber: {
        get () {
          if (this.$store.getters.boardingPass) {
            return this.$store.getters.boardingPass.flightNumber
          } else {
            return ''
          }
        }
      },
      flightDate: {
        get () {
          if (this.$store.getters.boardingPass) {
            let dateTime = LuxonDateTime.fromJSDate(this.$store.getters.boardingPass.date)
            // TODO move hardcoded format into constants or somewhere
            return dateTime.toFormat('dd LLL yyyy')
          } else {
            return ''
          }
        }
      },
      departureAirport: {
        get () {
          if (this.$store.getters.boardingPass) {
            let matchingAirport = this.airports.find(a => a.code === this.$store.getters.boardingPass.departure)
            if (matchingAirport) {
              return matchingAirport.displayKey
            }
            return this.$store.getters.boardingPass.departure
          } else {
            return ''
          }
        }
      },
      arrivalAirport: {
        get () {
          if (this.$store.getters.boardingPass) {
            let matchingAirport = this.airports.find(a => a.code === this.$store.getters.boardingPass.arrival)
            if (matchingAirport) {
              return matchingAirport.displayKey
            }
            return this.$store.getters.boardingPass.arrival
          } else {
            return ''
          }
        }
      },

      /**
       * Get temporary address toggle buttons
       */
      nextButton: {
        get () {
          return {
            state: ButtonStates.ENABLED,
            type: ButtonTypes.PRIMARY,
            text: 'message.boardingPassConfirm.yesProceedButton',
            id: DefaultNavigationButtons.NEXT.id
          }
        }
      },

      /**
       * Get temporary address toggle buttons
       */
      backButton: {
        get () {
          return {
            state: ButtonStates.ENABLED,
            type: ButtonTypes.SECONDARY,
            text: 'message.boardingPassConfirm.noScanAgainButton',
            id: DefaultNavigationButtons.BACK.id
          }
        }
      }
    },

    data: function () {
      return {
        airports: [],
        pagei18nKey: 'message.boardingPassConfirm',
        loading: true,
        activeId: null,
        successIcon: '/static/theme/img/success-icon.png',
        languages: []
      }
    },
    methods: {
      /**
       * On navigation button clicked change view based on clicked button id
       */
      navigationButtonClick: function (buttonId) {
        if (buttonId === DefaultNavigationButtons.BACK.id) {
          // clear the boarding pass data
          this.$store.commit('setBoardingPassConfirmed', false)
          this.$router.go(-1)
        } else if (buttonId === DefaultNavigationButtons.NEXT.id) {
          // update the user and flight data from the boarding pass obect
          this.$store.commit('setBoardingPassConfirmed', true)
          this.$router.push('/about')
        }
      },
      onEnterDetailsManuallyClicked () {
        console.log('on enter details manually clicked')
        // clear boarding pass!
        this.$store.commit('clearBoardingPassData')
        // and move on so user can enter manual details
        this.$router.push('/flight-details')
      }
    },
    beforeCreate () {
      console.log('scanning create')
    },
    mounted () {
      // if no boarding pass then go to scan option
      if (!this.$store.getters.boardingPass) {
        this.$router.replace('/boarding-pass-scan')
      }
      /**
       * Get airports list from api
       */
      api.getAirports()
        .then(response => {
          // Retrieve data and sort it
          this.airports = response.data.sort((x, y) => x.name.localeCompare(y.name))

          this.airports.forEach(airport => {
            airport.displayKey = airport.name + ' (' + airport.code + ')'
          })
        })
        .catch(console.error)
    }
  }
</script>

<style lang="scss">
  @import "../../assets/sass/main.scss";

  .boarding_pass_confirm {
    border-bottom: $default-border-style;
    @extend %app_form_container;
    * {
      text-align: center;
    }
  }

  .boarding_pass_confirm_image img {
    margin-bottom: $dims-spacing-small;
  }

  .boarding_pass_confirm_button__container {
    background-color: $secondary-brand-color;

    @include mobile {
      padding: 0 $dims-horizontal-gutter;
    }
  }

  .boarding_pass_confirm_label {
    text-align: right;
  }

  .boarding_pass_confirm_value {
    text-align: left;
  }

  .boarding_pass_enter_manually {
    margin: $dims-spacing-large 0 $dims-padding-default 0;
    text-align: center;

    .link-text {
      font-weight: $semibold-font-weight;
      color: $quaternary-text-color;
      cursor: pointer;
    }
  }

</style>
